import MobileViewSupplierInfo from "../Components/MobileViewSupplierInfo";
import { MobileViewSupplierInfoPropsTypes } from "../MobileViewSupplierInfoPropsTypes";

export default function MobileViewSupplierInfoContainer({
  surveyAnswersInfo,
  handleNextPage,
  monthsHash,
}: MobileViewSupplierInfoPropsTypes) {
  return (
    <MobileViewSupplierInfo
      surveyAnswersInfo={surveyAnswersInfo}
      monthsHash={monthsHash}
      handleNextPage={handleNextPage}
    />
  );
}
